import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

export const getAllConfigs = async () => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/configView`,
    );
    return response.data.map((item) => ({
      key: item.id,
      text: item.text,
      value: item.value,
    }));
  } catch (e) {
    console.error(e);
  }
};

export const configName = async (data) => {
  try {
    let id = data;
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/configView/name/${id}`,
    );
    return response.data;
  } catch (e) {}
};

export const getConfigDetails = async (id) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/configView/details/${id}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
    return null;
  }
};
